"use strict";
import { defaultAbiCoder } from "@ethersproject/abi";
import { getCreate2Address } from "@ethersproject/address";
import { keccak256 } from "@ethersproject/solidity";
import { ChainId, computeZksyncCreate2Address } from "@uniswap/sdk-core";
import { poolInitCodeHash } from "../constants";
export function computePoolAddress({
  factoryAddress,
  tokenA,
  tokenB,
  fee,
  initCodeHashManualOverride,
  chainId
}) {
  const [token0, token1] = tokenA.sortsBefore(tokenB) ? [tokenA, tokenB] : [tokenB, tokenA];
  const isBscChain = chainId === 97 || chainId === 56;
  if (isBscChain) {
    return "0x0000000000000000000000000000000000000000";
  }
  const salt = keccak256(
    ["bytes"],
    [defaultAbiCoder.encode(["address", "address", "uint24"], [token0.address, token1.address, fee])]
  );
  const initCodeHash = initCodeHashManualOverride ?? poolInitCodeHash(chainId);
  switch (chainId) {
    case ChainId.ZKSYNC:
      return computeZksyncCreate2Address(factoryAddress, initCodeHash, salt);
    default:
      return getCreate2Address(factoryAddress, salt, initCodeHash);
  }
}
